import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'id',
     field: FIELDS.ID,
     title: 'CAR Id',
     label: 'CAR Id',
     cell: 'navigation',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'rejectDate',
     field: FIELDS.REJECT_DATE,
     title: 'Reject Date',
     label: 'Reject Date',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'statusName',
     field: FIELDS.STATUS_NAME,
     title: 'Status',
     label: 'Status',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'customerName',
     field: FIELDS.CUSTOMER_NAME,
     title: 'Customer',
     label: 'Customer',
     sortable: true,
     hidden: false,
     width: 150,
  },{
      key: 'vendorName',
      field: FIELDS.VENDOR_NAME,
      title: 'Vendor',
      label: 'Vendor',
      sortable: true,
      hidden: false,
      width: 150,
   },{
     key: 'customerPo',
     field: FIELDS.CUSTOMER_PO,
     title: 'Customer PO',
     label: 'Customer PO',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'partNumber',
     field: FIELDS.PART_NUMBER,
     title: 'Part Number',
     label: 'Part Number',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'quantity',
     field: FIELDS.QUANTITY,
     title: 'Qty',
     label: 'Qty',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
      key: 'invoiceId',
      field: FIELDS.INVOICE_ID,
      title: 'Invoice No',
      label: 'Invoice No',
      sortable: true,
      hidden: true,
      width: 150,
   },{
      key: 'purchaseOrderId',
      field: FIELDS.PURCHASE_ORDER_ID,
      title: 'PO No',
      label: 'PO No',
      sortable: true,
      hidden: true,
      width: 150,
   },{
     key: 'section1',
     field: FIELDS.SECTION1,
     title: 'Section 1',
     label: 'Section 1',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'section2',
     field: FIELDS.SECTION2,
     title: 'Section 2',
     label: 'Section 2',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'section3',
     field: FIELDS.SECTION3,
     title: 'Section 3',
     label: 'Section 3',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'section4',
     field: FIELDS.SECTION4,
     title: 'Section 4',
     label: 'Section 4',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'section5',
     field: FIELDS.SECTION5,
     title: 'Section 5',
     label: 'Section 5',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'productEngineerName',
     field: FIELDS.PRODUCT_ENGINEER_NAME,
     title: 'Product Engineer',
     label: 'Product Engineer',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'productEngineerApproved',
     field: FIELDS.PRODUCT_ENGINEER_APPROVED,
     title: 'Product Engineer Approved',
     label: 'Product Engineer Approved',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'supplierQaName',
     field: FIELDS.SUPPLIER_QANAME,
     title: 'Supplier QA',
     label: 'Supplier QA',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'supplierQaApproved',
     field: FIELDS.SUPPLIER_QAAPPROVED,
     title: 'Supplier QA Approved',
     label: 'Supplier QA Approved',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'supplierQaDate',
     field: FIELDS.SUPPLIER_QADATE,
     title: 'Supplier QA Date',
     label: 'Supplier QA Date',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'supplierDirectorName',
     field: FIELDS.SUPPLIER_DIRECTOR_NAME,
     title: 'Supplier Director',
     label: 'Supplier Director',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'supplierDirectorApproved',
     field: FIELDS.SUPPLIER_DIRECTOR_APPROVED,
     title: 'Supplier Director Approved',
     label: 'Supplier Director Approved',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'supplierDirectorDate',
     field: FIELDS.SUPPLIER_DIRECTOR_DATE,
     title: 'Supplier Director Date',
     label: 'Supplier Director Date',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'createdByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'modifiedByUserFullName',
     field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'active',
     field: FIELDS.ACTIVE,
     title: 'Active',
     label: 'Active',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'aging',
     field: FIELDS.AGING,
     title: 'Aging',
     label: 'Aging',
     cell: 'formatSeparator',
     sortable: true,
     hidden: true,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
